<template>
    <div>
        <drawer />
        <v-card>
            <v-card-title> Usuarios registrados </v-card-title>
        </v-card>

        <v-container>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar usuario"
                single-line
                hide-details
                dense
            />
        </v-container>

        <v-container>
            <v-row>
                <v-data-table
                    :headers="headers"
                    :items="users"
                    :search="search"
                    item-key="id"
                    class="elevation-1"
                >

                <template v-slot:item.actions="{ item }">
                    <v-btn size="small" @click="handleAction(item)">Cambiar password</v-btn>
                </template>

                </v-data-table>

                <v-dialog v-model="showPasswordDialog" max-width="500">
                    <v-card>
                        <v-card-title class="headline">Cambiar contraseña</v-card-title>

                        <v-card-text>
                            <v-text-field
                                v-model="newPassword"
                                label="Nueva contraseña"
                                type="password"
                                required
                            />
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="grey" text @click="showPasswordDialog = false">Cancelar</v-btn>
                            <v-btn color="primary" text @click="changePassword">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-container>
    </div>
</template>

<script>

    import drawer from "../Drawer/Drawer.vue";
    import axios from "axios";

    export default{

        name: "userList",

        components: {
            drawer,
        },

        data(){
            return{
                headers: [
                    { text: "ID", value: "id", align: "center", sortable: true },
                    { text: "Email", value: "email" },
                    { text: "", value: "actions", sortable: false }
                ],

                users: [],
                search: "",
                showPasswordDialog: false,
                selectUser: null,
                newPassword: "",
            }
        },

        methods: {
            handleAction(item) {
                this.selectUser = item.id;
                this.showPasswordDialog = true;
            },

            async retrieveUsers() {
                const token = sessionStorage.getItem("jwtToken");

                try {
                    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

                    const response = await axios.get("https://fibackend.ujed.mx/alumnos/usuarios/");
                    this.users = response.data;
                } catch (error) {
                    console.error("Error al obtener usuarios:", error);
                }
            },

            async changePassword(){
                if (!this.newPassword || !this.selectUser) return;

                const token = sessionStorage.getItem("jwtToken");

                try{

                    await axios.put(`https://fibackend.ujed.mx/alumnos/usuarios/${this.selectUser}/`, {
                        password: this.newPassword,
                        },
                        {
                            headers:{
                                Authorization: `Bearer ${token}`,
                            }
                        }
                    );
                    alert("Contraseña actualizada correctamente.");
                    this.newPassword = "";
                    this.showPasswordDialog = false;

                }catch(error){
                    console.error("Error al cambiar la contraseña:", error);
                    alert("Error al cambiar la contraseña");
                }
            }
        },

        mounted(){
            this.retrieveUsers();
        }

    }

</script>